module.exports = __webpack_public_path__ + "static/media/NotoSansCJKkr-Light.1883dc03.otf";